import { DynamicFieldInstruction } from './shared';
export class InputCheckboxInstruction extends DynamicFieldInstruction {
  getDefaults() {
    return {
      infoText: null,
      large: false
    };
  }
  constructor(config) {
    super();
    /** object map of input name -> source name / function */
    this.inputMap = {
      label: 'infoText',
      large: 'large'
    };
    this.attributeMap = {};
    this.setConfig(config);
  }
  load() {
    return import(/* webpackChunkName: "ui-input-checkbox" */
    /* webpackMode: "lazy" */
    '@common/ui/frontend-shared/input-checkbox').then(m => m.UiInputCheckboxComponent);
  }
}